/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntityRelationship
 */
export interface EntityRelationship {
    /**
     * 
     * @type {string}
     * @memberof EntityRelationship
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityRelationship
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityRelationship
     */
    sourceEntityType?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityRelationship
     */
    sourceEntityId?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityRelationship
     */
    targetEntityType?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityRelationship
     */
    targetEntityId?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityRelationship
     */
    relationshipType?: EntityRelationshipRelationshipTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EntityRelationship
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof EntityRelationship
     */
    status?: EntityRelationshipStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof EntityRelationship
     */
    version?: number;
    /**
     * 
     * @type {Date}
     * @memberof EntityRelationship
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EntityRelationship
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof EntityRelationship
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityRelationship
     */
    updatedBy?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EntityRelationship
     */
    bidirectional?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EntityRelationship
     */
    reverseType?: EntityRelationshipReverseTypeEnum;
}


/**
 * @export
 */
export const EntityRelationshipRelationshipTypeEnum = {
    Hosts: 'HOSTS',
    Runs: 'RUNS',
    Instantiates: 'INSTANTIATES',
    HasVulnerability: 'HAS_VULNERABILITY',
    ParentChild: 'PARENT_CHILD',
    Owns: 'OWNS',
    HasAccount: 'HAS_ACCOUNT',
    LoggedOn: 'LOGGED_ON',
    AssociatedWith: 'ASSOCIATED_WITH',
    IsComputerAccountFor: 'IS_COMPUTER_ACCOUNT_FOR',
    Contains: 'CONTAINS',
    Affects: 'AFFECTS',
    UsesEncryptionKey: 'USES_ENCRYPTION_KEY',
    UsesStorage: 'USES_STORAGE',
    UsesDatabase: 'USES_DATABASE',
    DependsOn: 'DEPENDS_ON',
    ConnectsTo: 'CONNECTS_TO',
    BackedUpBy: 'BACKED_UP_BY',
    ReplicatedTo: 'REPLICATED_TO',
    Encrypts: 'ENCRYPTS',
    StoresDataIn: 'STORES_DATA_IN',
    RunsOn: 'RUNS_ON',
    Monitors: 'MONITORS',
    Secures: 'SECURES'
} as const;
export type EntityRelationshipRelationshipTypeEnum = typeof EntityRelationshipRelationshipTypeEnum[keyof typeof EntityRelationshipRelationshipTypeEnum];

/**
 * @export
 */
export const EntityRelationshipStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Decommissioned: 'DECOMMISSIONED',
    Deleted: 'DELETED'
} as const;
export type EntityRelationshipStatusEnum = typeof EntityRelationshipStatusEnum[keyof typeof EntityRelationshipStatusEnum];

/**
 * @export
 */
export const EntityRelationshipReverseTypeEnum = {
    Hosts: 'HOSTS',
    Runs: 'RUNS',
    Instantiates: 'INSTANTIATES',
    HasVulnerability: 'HAS_VULNERABILITY',
    ParentChild: 'PARENT_CHILD',
    Owns: 'OWNS',
    HasAccount: 'HAS_ACCOUNT',
    LoggedOn: 'LOGGED_ON',
    AssociatedWith: 'ASSOCIATED_WITH',
    IsComputerAccountFor: 'IS_COMPUTER_ACCOUNT_FOR',
    Contains: 'CONTAINS',
    Affects: 'AFFECTS',
    UsesEncryptionKey: 'USES_ENCRYPTION_KEY',
    UsesStorage: 'USES_STORAGE',
    UsesDatabase: 'USES_DATABASE',
    DependsOn: 'DEPENDS_ON',
    ConnectsTo: 'CONNECTS_TO',
    BackedUpBy: 'BACKED_UP_BY',
    ReplicatedTo: 'REPLICATED_TO',
    Encrypts: 'ENCRYPTS',
    StoresDataIn: 'STORES_DATA_IN',
    RunsOn: 'RUNS_ON',
    Monitors: 'MONITORS',
    Secures: 'SECURES'
} as const;
export type EntityRelationshipReverseTypeEnum = typeof EntityRelationshipReverseTypeEnum[keyof typeof EntityRelationshipReverseTypeEnum];


/**
 * Check if a given object implements the EntityRelationship interface.
 */
export function instanceOfEntityRelationship(value: object): value is EntityRelationship {
    return true;
}

export function EntityRelationshipFromJSON(json: any): EntityRelationship {
    return EntityRelationshipFromJSONTyped(json, false);
}

export function EntityRelationshipFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityRelationship {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'sourceEntityType': json['sourceEntityType'] == null ? undefined : json['sourceEntityType'],
        'sourceEntityId': json['sourceEntityId'] == null ? undefined : json['sourceEntityId'],
        'targetEntityType': json['targetEntityType'] == null ? undefined : json['targetEntityType'],
        'targetEntityId': json['targetEntityId'] == null ? undefined : json['targetEntityId'],
        'relationshipType': json['relationshipType'] == null ? undefined : json['relationshipType'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'status': json['status'] == null ? undefined : json['status'],
        'version': json['version'] == null ? undefined : json['version'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'bidirectional': json['bidirectional'] == null ? undefined : json['bidirectional'],
        'reverseType': json['reverseType'] == null ? undefined : json['reverseType'],
    };
}

export function EntityRelationshipToJSON(json: any): EntityRelationship {
    return EntityRelationshipToJSONTyped(json, false);
}

export function EntityRelationshipToJSONTyped(value?: EntityRelationship | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'sourceEntityType': value['sourceEntityType'],
        'sourceEntityId': value['sourceEntityId'],
        'targetEntityType': value['targetEntityType'],
        'targetEntityId': value['targetEntityId'],
        'relationshipType': value['relationshipType'],
        'metadata': value['metadata'],
        'status': value['status'],
        'version': value['version'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'bidirectional': value['bidirectional'],
        'reverseType': value['reverseType'],
    };
}

